export enum ReminderType {
    NORMAL = 1,
    EXPIRED = 2
}